// extracted by mini-css-extract-plugin
export default {"wrapper":"Mq-z","response":"Nq-z","error":"Oq-z","disabled":"Pq-z","buttons":"Qq-z","feedbackQuestionSection":"Rq-z","yesNoWrapper":"Sq-z"};